export const unique = (value: any, index: number, self: any) => {
    return self.indexOf(value) === index;
};

export const getCookieDomain = () =>
    location.host.split(".").slice(-2).join(".");
